import { render } from "./SideBar.vue?vue&type=template&id=1a8d295a&scoped=true&ts=true"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"

import "./SideBar.vue?vue&type=style&index=0&id=1a8d295a&scoped=true&lang=scss"

import exportComponent from "/Users/sylvainleris/Documents/workspace/ADETEC/AdConnect/fr.adetec.adconnect.www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8d295a"]])

export default __exports__